module.exports = __webpack_public_path__ + "img/14.4787bbb4.svg";